import { DistanceType, WeightType } from '../domain/driversProject/DriversProject';

export const kmToSM = (km: number, distanceIn: DistanceType): number => {
  if (distanceIn === `mi`) {
    return km * 0.621371;
  }
  return km;
};

export const SMToKm = (sm: number, distanceIn: DistanceType): number => {
  if (distanceIn === `mi`) {
    return sm / 0.621371;
  }
  return sm;
};

export const kgToLb = (kg: number, weightIn: WeightType): number => {
  if (weightIn === `lb`) {
    return kg * 2.20462;
  }
  return kg;
};
